import React from 'react';
import PropTypes from 'prop-types';
import SelectNestedMenuDialog from './common/SelectNestedMenuDialog';
import { investBusinessAreaNestedMenu } from '../../../../constants/SidebarValues';

// 「投資意欲を選択」UI のレイアウト微調整。
// トレンドグループ末尾の「はばたく中小企業・小規模事業者300社」(19 文字) が
// デフォルト 25% 列幅の text-overflow: ellipsis で末尾省略されていた。
//
// 列幅自体は均等 (25% × 4) に保ち、チェックボックスはトレンド/その他で縦位置を揃える。
// 4 列目のテキストだけ overflow を許可して列幅をはみ出して表示することで、
// その他グループおよび 1〜3 列目のレイアウトには一切影響しない。
//
// 4 列目以外で空欄のため、はみ出しがレイアウトに見える形で影響するのは
// 「はばたく中小企業・小規模事業者300社」が含まれる行のみ。
// 短い 4 列目 (例:「セキュリティ」「海外進出」等) は自然幅が列幅を超えないため
// 視覚的な変化なし。
const TREND_LAST_COL_TEXT_STYLE = {
  // 既定: text-overflow: ellipsis + overflow: hidden で省略される
  // → 上書き: 省略せず、自然な幅で表示
  textOverflow: 'clip',
  overflow: 'visible',
  // 自然なテキスト幅 (はみ出し前提) で確保する。flex shrink で詰められないよう保険。
  width: 'max-content',
  flexShrink: 0,
};

// SelectNestedMenuDialog の getItemTextStyle プロップ。
// トレンドグループの最終カラム (itemIndex % colCount === colCount - 1) のテキストだけ
// オーバーフロー許可スタイルを返す。他グループ・他カラム・colCount が 4 以外なら null。
const getItemTextStyle = (category, itemIndex, colCount) => {
  // eslint-disable-next-line no-magic-numbers
  if (category.value !== 'trend' || colCount !== 4) {
    return null;
  }
  const isLastColumn = itemIndex % colCount === colCount - 1;
  return isLastColumn ? TREND_LAST_COL_TEXT_STYLE : null;
};

const SelectInvestBusinessAreaDialog = (props) => (
  <SelectNestedMenuDialog
    {...props}
    title="投資意欲を選択"
    nestedMenu={investBusinessAreaNestedMenu}
    getItemTextStyle={getItemTextStyle}
  />
);

SelectInvestBusinessAreaDialog.propTypes = {
  toggleDialog: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  set: PropTypes.object,
  save: PropTypes.func.isRequired,
};

export { getItemTextStyle, TREND_LAST_COL_TEXT_STYLE };
export default SelectInvestBusinessAreaDialog;



// WEBPACK FOOTER //
// ./src/components/ExecutiveList/dialogs/SelectNestedMenuDialog/SelectInvestBusinessAreaDialog.jsx